import { Suspense } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loading } from "@/components/ui/loading";

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

export function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { user, loading } = useAuth();

  if (loading) {
    // grow: a guard a teljes oldalt helyettesíti (fejléc/lábléc nélkül), ezért a
    // töltőképernyő töltse ki a viewportot, ne a lap tetején lógjon egy pörgő ikon
    return <Loading label="Jogosultság ellenőrzése..." className="grow" />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Az admin keret és oldalak kódja külön töltődik (lásd pages/lazyPages.ts): a vendégeknek
  // nem kell letölteniük. Amíg jön, ugyanaz a teljes képernyős töltésjelző marad.
  return <Suspense fallback={<Loading className="grow" />}>{children}</Suspense>;
}
